<template>
  <div class="category" :id="'category' + p_category.intCategoryId" :class="p_category.strCssClass">
    <h2 class="category-inner" v-if="p_category.bitShowTitle">{{ p_category.strTitle }}</h2>
    <div class="category-slider-wrap">
      <div class="category-slider category-inner">
        <div v-for="i in Math.ceil(c_get_candys.length / 2)" :key="i">
          <template v-for="(v, k) in c_get_candys.slice((i - 1) * 2, i * 2)" :key="k">
            <v-candyticket :p_candy="v"></v-candyticket>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import CandyTicket from "./CandyTicket.vue";

export default {
  name: "candycategory",
  components: {
    "v-candyticket": CandyTicket
  },
  data() {
    return {
      slides: {}
    }
  },
  props: {
    p_category: { type: Object, default: () => null }
  },
  computed: {
    c_get_candys: function () {
      return this.p_category.Candys;
    }
  },
  updated() {
  },
  mounted() {
  }
};

</script>



// WEBPACK FOOTER //
// src/components/CandyCategory.vue